export default __webpack_public_path__ + "logo-FR-mobile.svg";